import { Component, OnInit, Input } from '@angular/core';

import { DecimalPipe } from '@angular/common'

import { ChartService } from '../../../services/chart.service';

@Component({
  selector: 'human-graph',
  templateUrl: './human-graph.component.html'
})
export class HumanGraphComponent implements OnInit {

  emailData: any;
  emailChartOptions: any;

  totalEmails: number = 0;
  totalHuman: number = 0;
  hasData: boolean = false;

  @Input()
  set data(data: any) {
    this.emailData = data;
    this.updateView();
  }

  constructor(private chartService: ChartService, private decimalPipe: DecimalPipe) {
    this.emailChartOptions = this.chartService.defaultChart;
    this.emailChartOptions.chart.type = 'column';
    this.emailChartOptions.chart.height = '320';
    this.emailChartOptions.legend.verticalAlign = 'top';
    this.emailChartOptions.legend.align = 'center';

    this.emailChartOptions.xAxis = {
      type: 'date',
      labels: {
        format: '{value:%b %d}'
      }
    };

    this.emailChartOptions.yAxis = [
      {
        title: {
          text: null
        },
        gridLineWidth: 1,
        tickWidth: 1,
        labels: {
          style: {
            fontSize: '14px'
          }
        }
      },
      {
        title: {
          text: null
        },
        gridLineWidth: 1,
        tickWidth: 1,
        opposite: true,
        labels: {
          style: {
            color: this.chartService.humanTrendColors[1],
            fontSize: '14px'
          }
        }
      }
    ];

    this.emailChartOptions.tooltip = {
      headerFormat: '{point.key:%b %d, %Y}<br/>',
      shared: true
    };

    this.emailChartOptions.plotOptions.column = {
      pointPadding: 0,
      borderWidth: 0
    };

    this.emailChartOptions.plotOptions.area = {
      pointPadding: 0,
      borderWidth: 0,
      marker: {
        enabled: false
      },
      lineWidth: 2,
      fillColor: 'rgba(229, 230, 237, 0.9)'
    };
   }

  ngOnInit() {
  }

  private updateView() {
    this.hasData = false;
    let total: any[] = [];
    let human: any[] = [];
    this.emailChartOptions.xAxis.categories = [];
    if (this.emailData && this.emailData.length > 0) {
      this.emailData.forEach((day) => {
        this.emailChartOptions.xAxis.categories.push(new Date(day.date));
        total.push(day.total_emails);
        human.push(day.human_emails);
        this.totalEmails += day.total_emails;
        this.totalHuman += day.human_emails;
      });

      this.emailChartOptions.series = [
        {
          name: `Total Replies (${this.decimalPipe.transform(this.totalEmails)})`,
          data: total,
          color: this.chartService.humanTrendColors[0],
          type: 'area',
          yAxis: 0
        },
        {
          name: `Human Replies (${this.decimalPipe.transform(this.totalHuman)})`,
          data: human,
          color: this.chartService.humanTrendColors[1],
          yAxis: 1
        }
      ];

      this.hasData = true;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/global/analytics/human-graph/human-graph.component.ts